import { render, staticRenderFns } from "./ServiceGroupForm.vue?vue&type=template&id=6ed8f495&"
import script from "./ServiceGroupForm.vue?vue&type=script&lang=js&"
export * from "./ServiceGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports